import { Router } from '@solidjs/router';
import { FileRoutes } from '@solidjs/start/router';
import { MetaProvider } from '@solidjs/meta';
import { useTrackEvent } from '@troon/analytics';
import { UIProvider } from '@troon/ui';
import './app.css';
import { withSentryRouterRouting } from '@sentry/solidstart/solidrouter';
import { UtmProvider } from '@troon/primitives/utm';
import { ServiceWorker } from './providers/service-worker';
import { getBaseUrl } from './modules/schema/base-url';
import { PersistenceProvider } from './providers/persistence-store';
import { UserContext } from './providers/user';

const SentryRouter = withSentryRouterRouting(Router);

export default function App() {
	const track = useTrackEvent();

	return (
		<SentryRouter
			explicitLinks
			preload
			root={(props) => (
				<PersistenceProvider>
					<UtmProvider>
						<ServiceWorker>
							<MetaProvider>
								<UIProvider
									baseUrl={getBaseUrl()}
									onDialogOpened={(key) => track('dialogOpened', { key }, { noDuplicates: true })}
									onDialogClosed={(key) => track('dialogClosed', { key }, { noDuplicates: true })}
								>
									<UserContext>{props.children}</UserContext>
								</UIProvider>
							</MetaProvider>
						</ServiceWorker>
					</UtmProvider>
				</PersistenceProvider>
			)}
		>
			<FileRoutes />
		</SentryRouter>
	);
}
